import { Tag } from '@loadsmart/loadsmart-ui'

import { Icon } from 'core/ui/components/icon/Icon'

import { getResultVariance } from '../domain/LaneProposal'
import { formatLaneResults } from '../presenters/lanePresenter'

export type RfpLaneResultType = {
  result?: string
}

export function RfpLaneResult({ result }: RfpLaneResultType) {
  if (!result) return null

  const resultVariance = getResultVariance(result)
  const value = formatLaneResults(result)
  const iconName = resultVariance === 'positive' ? 'arrows-corner-up' : 'arrows-corner-down'
  const variant = resultVariance === 'positive' ? 'danger' : 'success'

  return (
    <Tag variant={variant} leading={<Icon name={iconName} />}>
      {value}
    </Tag>
  )
}
